import React from 'react';

function TimersPreview() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="108"
      height="108"
      viewBox="0 0 108 108"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <path fill="#FFF" d="M0 0H108V108H0z" />
        <path
          fill="#EFEFEF"
          d="M93 98a4 4 0 014 4v6H10v-6a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V73a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V44a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V15a4 4 0 014-4h79z"
        />
        <rect width="43" height="30" x="33" y="39" fill="currentColor" rx="4" />
        <path
          fill="#FFF"
          fillRule="nonzero"
          d="M44.653 58.568c1.135 0 2.02-.256 2.652-.767.633-.511.949-1.205.949-2.08 0-.598-.165-1.081-.494-1.45-.33-.368-.767-.613-1.313-.734.468-.165.84-.412 1.118-.741.277-.33.416-.754.416-1.274 0-.364-.074-.7-.221-1.008a2.305 2.305 0 00-.637-.799 3.036 3.036 0 00-1.014-.527A4.539 4.539 0 0044.744 49a4.23 4.23 0 00-1.417.221 3.064 3.064 0 00-1.053.611 2.814 2.814 0 00-.682.943c-.16.36-.254.751-.28 1.176h1.859c.052-.442.21-.787.474-1.034.265-.247.618-.37 1.06-.37.433 0 .756.11.968.332.213.22.319.496.319.825 0 .399-.113.704-.338.916-.225.213-.585.319-1.079.319h-.676v1.404h.728c.503 0 .877.11 1.124.331.248.221.371.557.371 1.008 0 .416-.126.743-.377.981-.251.239-.641.358-1.17.358-.563 0-.973-.145-1.229-.435-.255-.29-.405-.661-.448-1.112H41c.043.945.366 1.697.968 2.256.603.559 1.498.838 2.685.838zm14.404-.143v-1.599h-3.614l1.755-1.716c.537-.52.97-1.044 1.3-1.573.33-.529.494-1.1.494-1.716 0-.416-.072-.797-.214-1.144a2.538 2.538 0 00-.618-.897 3.022 3.022 0 00-1.02-.572A4.203 4.203 0 0055.767 49c-1.049 0-1.879.282-2.49.845-.61.563-.942 1.387-.994 2.47h1.911c.07-.615.23-1.053.481-1.313s.585-.39 1.001-.39c.407 0 .715.113.923.338.208.225.312.533.312.923 0 .425-.132.847-.396 1.268a8.9 8.9 0 01-1.073 1.345l-3.406 3.601v.338h7.02zm7.982 0V49.13h-1.846l-2.145 1.521v1.794l1.885-1.235v7.215h2.106z"
        />
      </g>
    </svg>
  );
}

export default TimersPreview;



// WEBPACK FOOTER //
// ./src/components/modules/Examples/TimersPreview.js